export default "__VITE_ASSET__tcC46XRT__"